// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__qQZwz","postfix":"styles_postfix__xVZUu","prefix":"styles_prefix___O6IV"};